export const reportIsReady = () => {
  const customWindow = window as Window & { gotenberg?: boolean }

  customWindow.gotenberg = true
}
